/** @jsx jsx */
import { Link } from "gatsby"
import { jsx } from "theme-ui"

export const ListLink = ({ to, children }) => (
  <li>
    <Link to={to}>{children}</Link>
  </li>
)
